module.exports = __webpack_public_path__ + "img/homepage_banner_img.1a16830d.svg";